export const DATA_EXPORT_FORMATS = [
  'csv',
  'json',
  'xlsx',
  'pdf',
  'eml',
] as const;
